import { useState } from "react";
import { ChevronDown } from "lucide-react";

export default function DisclaimerRibbon() {
  const [open, setOpen] = useState(false);
  return (
    <button type="button" data-testid="blinddate-disclaimer" onClick={() => setOpen((o) => !o)} aria-expanded={open}
      className="w-full bg-white/[0.03] border-b border-white/10 px-4 py-2 text-left sm:text-center">
      <p className={`text-[11px] leading-snug text-muted-foreground tracking-wide max-w-3xl mx-auto ${open ? "" : "truncate"}`}>
        <ChevronDown className={`inline w-3 h-3 mr-1 transition-transform ${open ? "rotate-180" : ""}`} />
        <span className="font-semibold text-white/70">Notice:</span> All interaction vectors mapped inside the current
        terminal zone communicate with an autonomous generative intelligence model simulating localized human
        conversational parameters. Interaction metrics execute under automated grid simulations.
      </p>
    </button>
  );
}
